export const ShimmerSkeleton = ({ lines = 6 }) => {
  return (
    <div
      style={{
        borderRadius: 8,
        flex: 1,
        overflowY: "auto",
        maxHeight: "580px",
        wordWrap: "break-word",
      }}
    >
      {Array.from({ length: lines }).map((_, i) => (
        <div
          key={i}
          style={{
            height: 20,
            borderRadius: 6,
            width: "30%",
            background:
              "linear-gradient(90deg, #e8e8e8 0%, #f5f5f5 50%, #e8e8e8 100%)",
            backgroundSize: "200% 100%",
            animation: "shimmer 1.2s linear infinite",
          }}
        />
      ))}

      <style>{`
        @keyframes shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>
    </div>
  );
};
